var moduleMap = {
	"./App": function() {
		return Promise.all([__webpack_require__.e(3530), __webpack_require__.e(1888), __webpack_require__.e(8577), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(868), __webpack_require__.e(9107), __webpack_require__.e(6527), __webpack_require__.e(1667), __webpack_require__.e(2512), __webpack_require__.e(4549)]).then(function() { return function() { return (__webpack_require__(2950)); }; });
	},
	"./SIVCockpit": function() {
		return Promise.all([__webpack_require__.e(1888), __webpack_require__.e(8577), __webpack_require__.e(829), __webpack_require__.e(272), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(868), __webpack_require__.e(6527), __webpack_require__.e(5220), __webpack_require__.e(8250)]).then(function() { return function() { return (__webpack_require__(9260)); }; });
	},
	"./CreateSiv": function() {
		return Promise.all([__webpack_require__.e(3530), __webpack_require__.e(829), __webpack_require__.e(6347), __webpack_require__.e(8825), __webpack_require__.e(7597), __webpack_require__.e(868), __webpack_require__.e(9107), __webpack_require__.e(6117)]).then(function() { return function() { return (__webpack_require__(8873)); }; });
	}
};
var get = function(module, getScope) {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(function() {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = function(shareScope, initScope) {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: function() { return get; },
	init: function() { return init; }
});